import { render, staticRenderFns } from "./RegisterTermsAndCondition.vue?vue&type=template&id=f77af8e4&"
import script from "./RegisterTermsAndCondition.vue?vue&type=script&lang=ts&"
export * from "./RegisterTermsAndCondition.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterTermsAndCondition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports